module.exports = __webpack_public_path__ + "img/title_jyzz.335298ca.jpg";